import { useEffect, useState } from "react";

const useShopBy = (data) => {
  const [shopByItems, setShopByItems] = useState([]);

  useEffect(() => {
    if (!data || typeof data !== "object") {
      setShopByItems([]);
      return;
    }

    const formattedItems = Object.entries(data)
      .filter(([_, items]) => items.length > 0) // skip empty categories
      .map(([key, items = []]) => ({
        id: key,
        label: formatLabel(key),
        thumbs: items
          .sort((a, b) => (a.sequence || 0) - (b.sequence || 0)) // sort by sequence
          .map((v) => v.media)
          .filter(Boolean),
        url: items?.[0]?.action_url || "#",
        sale: key.toLowerCase().includes("sale"),
      }));

    setShopByItems(formattedItems);
  }, [data]);

  return shopByItems;
};

export default useShopBy;

/* helper to format labels like "Bath_Care" => "Bath Care" */
function formatLabel(key) {
  return key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}